import { env } from "@/config/env";

export const MOCKED_VIDEO_CHAT_STORIES = [
  {
    asanaResourceSubtype: "assignee",
    asanaResourceType: "activity",
    attachmentId: null,
    batchId: "3d293aae-a8b6-47b8-8a88-e34cc08b378f",
    chatType: String.raw`App\Models\Request-activity-assignee`,
    coEditors: null,
    comment: "<b>Queue Automation</b> has set assignee to <b>Mark H</b>",
    commentBatchId: "3d293aae-a8b6-47b8-8a88-e34cc08b378f",
    coordinates: null,
    createdAt: "2025-10-21T17:42:21.000Z",
    id: 2_033_799,
    isEdited: false,
    isNotified: true,
    isResolved: null,
    newValue: "Felipe Graphic Assistant",
    newValueReference: "5548",
    oldValue: null,
    oldValueReference: null,
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T17:42:21.000Z",
    user: {
      id: null,
      name: null,
      profilePhotoPath: null,
      // eslint-disable-next-line sonarjs/no-duplicate-string
      utcOffset: "America/Sao_Paulo",
    },
    userId: null,
  },

  {
    asanaResourceSubtype: "created",
    asanaResourceType: "activity",
    attachmentId: null,
    batchId: "3d293aae-a8b6-47b8-8a88-e34cc08b378f",
    chatType: String.raw`App\Models\Request-activity-created`,
    coEditors: null,
    comment: "<b>Sarah T</b> has created this <b>request</b>",
    commentBatchId: "3d293aae-a8b6-47b8-8a88-e34cc08b378f",
    coordinates: null,
    createdAt: "2025-10-21T17:42:21.000Z",
    id: 2_033_800,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: "request",
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T17:42:21.000Z",
    user: {
      id: 5560,
      name: "Sarah T",
      profilePhotoPath: null,
      utcOffset: "America/Sao_Paulo",
    },
    userId: 5560,
  },

  {
    asanaResourceSubtype: "comment_added",
    asanaResourceType: "story",
    attachmentId: null,
    batchId: "92077c7a-7b8f-4f80-b80c-7e1e275bd94a",
    chatType: "App\Models\Request-story-comment_added" as const,
    coEditors: null,
    comment:
      "<p>Hi @Sarah T, thank you for submitting your request! A designer will be assigned shortly and we’ll start working on the video ads. Feel free to add any extra details if needed.</p>",
    commentBatchId: "92077c7a-7b8f-4f80-b80c-7e1e275bd94a",
    coordinates: null,
    createdAt: "2025-10-21T14:43:49.000Z",
    id: 2_033_801,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: null,
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T14:43:49.000Z",
    user: {
      id: 2,
      name: "Mark H",
      profilePhotoPath:
        "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Videos+Template/video_team_leader_profile_pic.png",
      utcOffset: "America/Sao_Paulo",
    },
    userId: 2,
  },

  {
    asanaResourceSubtype: "assignee",
    asanaResourceType: "activity",
    attachmentId: null,
    batchId: "e5b68ee4-16fe-4de1-bdc6-2ab59e7b17f6",
    chatType: String.raw`App\Models\Request-activity-assignee`,
    coEditors: null,
    comment:
      "<b>Mark H</b> has changed designer from <b>Mark H</b> to <b>Jason G</b>",
    commentBatchId: "36ab8654-17ef-4109-b597-41c94ac85574",
    coordinates: null,
    createdAt: "2025-10-21T14:44:26.000Z",
    id: 2_033_802,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: "Jason G",
    newValueReference: "125",
    oldValue: "Felipe Graphic Assistant",
    oldValueReference: "5548",
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T14:44:26.000Z",
    user: {
      id: 2,
      name: "Mark H",
      profilePhotoPath:
        "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Videos+Template/video_team_leader_profile_pic.png",
      utcOffset: "America/Sao_Paulo",
    },
    userId: 2,
  },

  {
    asanaResourceSubtype: "due_on",
    asanaResourceType: "activity",
    attachmentId: null,
    batchId: "6f4fa6a7-c9ff-412b-8e55-f61c81d69c40",
    chatType: String.raw`App\Models\Request-activity-due_on`,
    coEditors: null,
    comment:
      "<b>Mark H</b> has changed duedate from <b><i>None</i></b> to <b>Wed Oct 22 2025</b>",
    commentBatchId: "a68a5c8e-932f-40ba-9b08-036a8f1569fe",
    coordinates: null,
    createdAt: "2025-10-21T14:46:11.000Z",
    id: 2_033_803,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: "Wed Oct 22 2025 01:00:00 GMT-0300 (Brasilia Standard Time)",
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T14:46:11.000Z",
    user: {
      id: 2,
      name: "Mark H",
      profilePhotoPath:
        "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Videos+Template/video_team_leader_profile_pic.png",
      utcOffset: "America/Sao_Paulo",
    },
    userId: 2,
  },

  {
    asanaResourceSubtype: "comment_added",
    asanaResourceType: "story",
    attachmentId: null,
    batchId: "4b68b334-0975-454f-8853-68ff4f321c3c",
    chatType: String.raw`App\Models\Request-story-comment_added`,
    coEditors: null,
    comment:
      "<p>Hello @Sarah T, I’ll be your designer for this project. I’ll produce the 15s lifestyle promo and the 30s app walkthrough according to your storyboard notes. I’ll send previews for feedback soon.</p>",
    commentBatchId: "4b68b334-0975-454f-8853-68ff4f321c3c",
    coordinates: null,
    createdAt: "2025-10-21T14:54:44.000Z",
    id: 2_033_804,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: null,
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T14:54:44.000Z",
    user: {
      id: 125,
      name: "Jason G",
      profilePhotoPath:
        // eslint-disable-next-line sonarjs/no-duplicate-string
        "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/profile_pic.png",
      utcOffset: "America/Sao_Paulo",
    },
    userId: 125,
  },

  {
    asanaResourceSubtype: "comment_added",
    asanaResourceType: "story",
    attachmentId: null,
    // eslint-disable-next-line sonarjs/no-duplicate-string
    batchId: "3a0b126b-9726-4dd8-bec4-bd7b89443008",
    chatType: String.raw`App\Models\Request-story-comment_added`,
    coEditors: null,
    comment: `<p>Hi again @Sarah T, the first drafts are ready! Both videos follow your structure: the 15s promo is upbeat and energetic, and the 30s walkthrough combines app screens with lifestyle shots. The second video I will send it after you approve this design here: <a href=\'${env.VITE_BASE_URL}/my-files/template?requestType=video\'>Source files link</a>.</p>`,
    commentBatchId: "3a0b126b-9726-4dd8-bec4-bd7b89443008",
    coordinates: null,

    // eslint-disable-next-line sonarjs/no-duplicate-string
    createdAt: "2025-10-21T15:07:25.000Z",
    id: 2_033_810,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: null,
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: "a:0:{}",
    updatedAt: "2025-10-21T15:07:25.000Z",
    user: {
      id: 125,
      name: "Jason G",
      profilePhotoPath:
        "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/profile_pic.png",
      utcOffset: "America/Sao_Paulo",
    },
    userId: 125,
  },

  {
    asanaResourceSubtype: "attachment_added",
    asanaResourceType: "attachment",
    attachment: {
      category: "my-file",
      id: 937_490,
      name: "1-1080x1920 - v1 - JG",
      path: "request-templates/Videos+Template/1-1080x1920.mp4",
      url: "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Videos+Template/1-1080x1920.mp4",
    },
    attachmentId: 937_490,
    batchId: "3a0b126b-9726-4dd8-bec4-bd7b89443008",
    chatType: String.raw`App\Models\Request-attachment-attachment_added`,
    coEditors: null,
    comment: "1-1080x1920 - v1 - JG",
    commentBatchId: "3a0b126b-9726-4dd8-bec4-bd7b89443008",
    coordinates: null,
    createdAt: "2025-10-21T15:07:25.000Z",
    id: 2_033_811,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: null,
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T15:07:25.000Z",
    user: {
      id: 125,
      name: "Jason G",
      profilePhotoPath:
        "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/profile_pic.png",
      utcOffset: "America/Sao_Paulo",
    },
    userId: 125,
  },

  {
    asanaResourceSubtype: "status",
    asanaResourceType: "activity",
    attachmentId: null,
    batchId: "6bcbd490-0c2a-48ed-a9c8-94a5f301c6c7",
    chatType: String.raw`App\Models\Request-activity-status`,
    coEditors: null,
    comment:
      "<b>Jason G</b> has changed status from <b>Processing Request</b> to <b>Ready for Review</b>",
    commentBatchId: "c15dc14f-12ee-421c-9d34-e018c1427c54",
    coordinates: null,
    createdAt: "2025-10-21T15:08:40.000Z",
    id: 2_033_815,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: "Ready for Review",
    newValueReference: "3",
    oldValue: "Processing Request",
    oldValueReference: "4",
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T15:08:40.000Z",
    user: {
      id: 125,
      name: "Jason G",
      profilePhotoPath:
        "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/profile_pic.png",
      utcOffset: "America/Sao_Paulo",
    },
    userId: 125,
  },

  {
    asanaResourceSubtype: "comment_added",
    asanaResourceType: "story",
    attachmentId: null,
    batchId: "055230e8-6521-40ae-a002-8e2f403b1b8b",
    chatType: String.raw`App\Models\Request-story-comment_added`,
    coEditors: null,
    comment:
      "<p>Thanks, @Jason G! They look really good, I love the energy of the 15s version. Could you work on the 30 seconds video now?</p>",
    commentBatchId: "055230e8-6521-40ae-a002-8e2f403b1b8b",
    coordinates: null,
    createdAt: "2025-10-21T15:09:39.000Z",
    id: 2_033_816,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: null,
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T15:09:39.000Z",
    user: {
      id: 5560,
      name: "Sarah T",
      profilePhotoPath: null,
      utcOffset: "America/Sao_Paulo",
    },
    userId: 5560,
  },

  {
    asanaResourceSubtype: "markup_comment_added",
    asanaResourceType: "activity",
    attachment: {
      category: "my-file",
      id: 0,
      name: "1-1080x1920.mp4",
      path: "/request-templates/Videos+Template/1-1080x1920.mp4",
      url: "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Videos+Template/1-1080x1920.mp4",
    },
    attachmentId: 937_499,
    batchId: "7cc63b8e-9b84-44ea-8425-0c7d081f182d",
    chatType: String.raw`App\Models\Request-activity-markup_comment_added`,
    coEditors: null,
    comment: "<b>Sarah T left feedback</b>",
    commentBatchId: "7cc63b8e-9b84-44ea-8425-0c7d081f182d",
    coordinates: null,
    createdAt: "2025-10-21T15:53:52.000Z",
    id: 2_033_845,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: "",
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 85_654,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-31T15:53:52.000Z",
    user: {
      id: 0,
      name: "Sarah T",
      profilePhotoPath: null,
      utcOffset: "America/New_York",
    },
    userId: 0,
  },

  {
    asanaResourceSubtype: "comment_added",
    asanaResourceType: "story",
    attachmentId: null,
    batchId: "7cc63b8e-9b84-44ea-8425-0c7d081f182d",
    chatType: String.raw`App\Models\Attachment-story-comment_added`,
    coEditors: null,
    comment: "<p>I approve, this looks great!</p>",
    commentBatchId: "7cc63b8e-9b84-44ea-8425-0c7d081f182d",
    coordinates: "39.12560848789361%,53.911936442057296%,0",
    createdAt: "2025-10-31T15:53:52.000Z",
    id: 2_033_844,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: null,
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 937_499,
    parentType: String.raw`App\Models\Attachment`,
    taggedUserIds: null,
    updatedAt: "2025-10-31T15:53:52.000Z",
    user: {
      id: 5560,
      name: "Felipe Ow",
      profilePhotoPath: null,
      utcOffset: "America/New_York",
    },
    userId: 5560,
  },

  {
    asanaResourceSubtype: "status",
    asanaResourceType: "activity",
    attachmentId: null,
    batchId: "68e7f4b7-c127-471b-9b57-8d8c209f12df",
    chatType: String.raw`App\Models\Request-activity-status`,
    coEditors: null,
    comment:
      "<b>Sarah T</b> has changed status from <b>Ready for Review</b> to <b>Being Revised</b>",
    commentBatchId: "c0e41995-0dc0-405b-a63b-3f29c0dd3ff2",
    coordinates: null,
    createdAt: "2025-10-21T15:11:30.000Z",
    id: 2_033_819,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: "Being Revised",
    newValueReference: "2",
    oldValue: "Ready for Review",
    oldValueReference: "3",
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T15:11:30.000Z",
    user: {
      id: 5560,
      name: "Sarah T",
      profilePhotoPath: null,
      utcOffset: "America/Sao_Paulo",
    },
    userId: 5560,
  },

  {
    asanaResourceSubtype: "comment_added",
    asanaResourceType: "story",
    attachmentId: null,
    batchId: "34fc9da5-92b9-42e2-bf2d-c3e113fe9ebc",
    chatType: String.raw`App\Models\Request-story-comment_added`,
    coEditors: null,
    comment: `<p>Glad to hear! Here is the other video for you review: <a href=\'${env.VITE_BASE_URL}/my-files/template?requestType=video\'>Source files link</a>.</p>`,
    commentBatchId: "34fc9da5-92b9-42e2-bf2d-c3e113fe9ebc",
    coordinates: null,
    createdAt: "2025-10-21T15:14:27.000Z",
    id: 2_033_820,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: null,
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T15:14:27.000Z",
    user: {
      id: 125,
      name: "Jason G",
      profilePhotoPath:
        "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/profile_pic.png",
      utcOffset: "America/Sao_Paulo",
    },
    userId: 125,
  },

  {
    asanaResourceSubtype: "attachment_added",
    asanaResourceType: "attachment",
    attachment: {
      category: "my-file",
      id: 937_494,
      name: "2-1080x1920",
      path: "request-templates/Videos+Template/2-1080x1920.mp4",
      url: "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Videos+Template/2-1080x1920.mp4",
    },
    attachmentId: 937_494,
    batchId: "34fc9da5-92b9-42e2-bf2d-c3e113fe9ebc",
    chatType: String.raw`App\Models\Request-attachment-attachment_added`,
    coEditors: null,
    comment: "2-1080x1920.mp4",
    commentBatchId: "34fc9da5-92b9-42e2-bf2d-c3e113fe9ebc",
    coordinates: null,
    createdAt: "2025-10-21T15:15:06.000Z",
    id: 2_033_822,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: null,
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 85_611,
    parentType: String.raw`App\Models\Request`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T15:15:06.000Z",
    user: {
      id: 125,
      name: "Jason G",
      profilePhotoPath:
        "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/profile_pic.png",
      utcOffset: "America/Sao_Paulo",
    },
    userId: 125,
  },
  {
    asanaResourceSubtype: "comment_added",
    asanaResourceType: "story",
    attachmentId: null,
    batchId: "1c45d635-cbed-4001-81b7-7d963563832b",
    chatType: String.raw`App\Models\Attachment-story-commeFnt_added`,
    coEditors: null,
    comment:
      "<p>Perfect, that feels much smoother. Great work, thank you @Jason G!</p>",
    commentBatchId: "1c45d635-cbed-4001-81b7-7d963563832b",
    coordinates: "27.42755635579427%,74.01800537109375%",
    createdAt: "2025-10-21T15:11:30.000Z",
    id: 2_033_817,
    isEdited: false,
    isNotified: false,
    isResolved: null,
    newValue: null,
    newValueReference: null,
    oldValue: null,
    oldValueReference: null,
    parentId: 937_491,
    parentType: String.raw`App\Models\Attachment`,
    taggedUserIds: null,
    updatedAt: "2025-10-21T15:11:30.000Z",
    user: {
      id: 5560,
      name: "Sarah T",
      profilePhotoPath: null,
      utcOffset: "America/Sao_Paulo",
    },
    userId: 5560,
  },
];

export const FEEDBACK_TOOL_VIDEO_TEMPLATE_DATA = [
  {
    attachments: [],
    comment: "<p>I approve, this looks great!</p>",
    commentBatchId: "1c45d635-cbed-4001-81b7-7d963563832b",
    coordinates: "27.42755635579427%,74.01800537109375%",
    createdAt: "2025-10-21T15:11:30.000Z",
    id: 0,
    isEdited: false,
    isResolved: false,
    parentId: 0,
    updatedAt: "2025-10-21T16:29:21.000Z",
    user: {
      id: 0,
      name: "Sarah T",
    },
  },
];
